// authModalContext.tsx
import React, { createContext, useState, useContext, ReactNode, useRef } from 'react';
import { useSelector } from "react-redux";

interface AuthModalContextType {
  isModalOpen: boolean;
  openModal: (cb: (user: any) => void) => void;
  closeModal: () => void;
  token: string;
  user: any;
  callPrevAction: () => void;
  resetPrevAction: () => void;
}

const AuthModalContext = createContext<AuthModalContextType | undefined>(undefined);

interface AuthModalProviderProps {
  children: ReactNode;
}

export const AuthModalProvider: React.FC<AuthModalProviderProps> = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const auth = useSelector((state: any) => state.Auth);
  const cbRef = useRef<any>(() => {});
  // const { requestAdmob, admobData, navigateData } = useRequestAdmob();

  // useEffect(() => {
  //   if (admobData) {
  //     setIsModalOpen(true)
  //     cbRef.current = navigateData.cb;
  //   }
  // }, [admobData, navigateData?.cb]);

  const openModal = (cb: (user: any) => void) => {
    // if (
    //   ["ios", "android"].includes((window as any)._APP_PLATFORM.toLowerCase())
    // ){
    //   requestAdmob(cb);
    // }else{
    //   setIsModalOpen(true)
    //   cbRef.current = cb;
    // }
    setIsModalOpen(true)
    cbRef.current = cb;
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const callPrevAction = () => {
    setTimeout(() => {
      cbRef.current(auth.userInfo);
      cbRef.current = () => {};
    }, 200);
  }

  const resetPrevAction = () => {
    cbRef.current = () => {};
  };

  return (
    <AuthModalContext.Provider value={{
      isModalOpen,
      openModal,
      closeModal,
      token: auth.token,
      user: auth.userInfo,
      callPrevAction,
      resetPrevAction,
    }}>
      {children}
    </AuthModalContext.Provider>
  );
};

export const useAuthModal = (): AuthModalContextType => {
  const context = useContext(AuthModalContext);
  if (!context) {
    throw new Error('useAuthModal must be used within a AuthModalProvider');
  }
  return context;
};
